module.exports = __webpack_public_path__ + "static/media/9.66c4ea72.jpg";